import _ from "lodash";

export const Config = {

    instance: null,

    getInstance() {
        if (!Config.instance) {
            Config.instance = _.extend({
                host: '',
                rtc_host: 'https://wr.simplybook.it',
                mode: 'button', // 'button' (default) or 'inline' (auto-open, no button)
                support_md: false, // Enable markdown formatting in messages
                is_admin: false, // Admin side features (new chat button, etc.)
                live_agent_available: false, // Live-help chat (the sb:call_support listener) is loaded on this page
            }, (global || window).ai_widget_config || {}, JSON.parse(document?.getElementById("sb_ai_widget").getAttribute("data-config")));
        }
        return Config.instance;
    }

};